const Navbar = () => <h2>Product Listing</h2>;
export default Navbar;